import React, { Component } from "react";
import {
  getAnswers,
  updateQuestionAnswers,
} from "../../../../services/formService";
import { getProjectLists } from "../../../../services/projectService";

class TypePicklist extends Component {
  Lists = [];

  state = {
    Project_ID: this.props.Project_ID,
    Question_ID: this.props.Question_ID,
    Question_Answers: [{ Answer_ID: 0, Answer_Text: "" }],
    loading: true,
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    const { data: Lists } = await getProjectLists(this.state.Project_ID);
    this.Lists = Lists;

    let { data: Question_Answers } = await getAnswers(this.state.Question_ID);
    if (Question_Answers.length === 0) {
      Question_Answers = [{ Answer_ID: 0, Answer_Text: "" }];
    }
    this.setState({ Question_Answers });
    this.setState({ loading: false });
  }

  async handleSave() {
    const Question_ID = await this.props.onSave(this.state.Question_Answers);
    this.setState({ Question_ID });
  }

  handleRemove() {
    this.props.onRemove();
  }

  handleListChange = (value) => {
    const Question_Answers = [...this.state.Question_Answers];
    Question_Answers[0]["Answer_Text"] = parseInt(value);
    this.setState({ Question_Answers });
  };

  render() {
    if (this.state.loading) return <div className="center">Loading...</div>;
    let { Question_Answers } = this.state;
 
    return (
      <React.Fragment>
        <div className="form-group">
          <label>Select List</label>
          <select
            className="custom-select"
            value={Question_Answers[0].Answer_Text}
            onChange={(e) => this.handleListChange(e.target.value)}
          >
            <option>Please Select</option>
            {this.Lists.map((list) => {
              return (
                <option key={list.List_ID} value={list.List_ID}>
                  {list.List_Name}
                </option>
              );
            })}
          </select>
        </div>

        <div className="float-right">
          <button
            className="btn btn-outline-primary m-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default TypePicklist;
